import { createContext, useContext } from 'react';

export const defaultTranslationStrings = {
    Alert: {
        Dismiss: 'Dismiss',
    },
    Modal: {
        Close: 'Close',
    },
    Select: {
        Open: 'Open',
    },
};

export type TranslationStrings = typeof defaultTranslationStrings;

export interface Props {
    translationStrings: TranslationStrings;
}

export const Context = createContext({ translationStrings: defaultTranslationStrings });

export function useTranslations() {
    const { translationStrings } = useContext(Context);
    return translationStrings;
}
